// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"a6e172cd","510":"f0003e15","777":"82e0435c"}[chunkId] + ".chunk.js";
};